var React = require('react');

function AddIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Shape"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"id":"Icons-/-Add-Remove-/-Outline-/-Without-BG-/-Circular-Add","stroke":"#5E5E5E","strokeWidth":"1.5"},React.createElement("path",{"d":"M12,23.249 C18.2132034,23.249 23.25,18.2122034 23.25,11.999 C23.25,5.78579656 18.2132034,0.749 12,0.749 C5.78679656,0.749 0.75,5.78579656 0.75,11.999 C0.75,18.2122034 5.78679656,23.249 12,23.249 Z M5.63603897,11.999 L18.363961,11.999 M12,18.362961 L12,5.63503897","id":"Shape"})))]);
}

AddIcon.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = AddIcon;

AddIcon.default = AddIcon;
